import { LoadIdView } from '../../../models';

export class ShipmentLoadItemSetIdentifier {
  public static readonly type = '[ShipmentLoadItem] Set Shipment Waybill Identifier';
  constructor(public payload: LoadIdView) {}
}

export class ShipmentLoadItemSetInitial {
  public static readonly type = '[ShipmentLoadItem] Set Initial State';
}

export class ShipmentLoadDemurrageAndDetentionTab {
  public static readonly type = '[ShipmentLoadItem] Get Shipment Load D&D tab';
  constructor(public payload: LoadIdView) {}
}
